import { Circle } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React, { useEffect,useRef } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel, Keyboard } from "swiper";
// import { balanceOfAssetsLinks } from "../../constants/constants";
import { nextCard, preCard, resetCard } from "../../redux/slices/CardSlices";
import { connect } from "react-redux";
import upArrow from "../../assets/icons/up-arrow.png";
import downArrow from "../../assets/icons/down-arrow.png";
import { useTranslation } from "react-i18next";
import { getUserIdFromLocalStorage } from "../../utils/Utilities";
import { getUpdatedData } from "../../redux/slices/AuditTrailSlice";
import { assetStepsNames } from "../../constants/constants";
import { getAutditTrail } from "../../services/auditTrails";
const Steps = (props) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  const swiperScroll = useRef(null);

  const handleSwiperScroll = (swiper) => {
    swiperScroll.current = swiper;
  };
  useEffect(() => {
    if (swiperScroll.current && props.tab===5||props.tab===6||props.tab===7||props.tabs===8||props.tab===9 && props.currentCard === 1) {
      swiperScroll.current.slideNext();
    }
  }, [props.currentCard, props.tab]); 

  const fetchAuditTrail = async () => {
    const result = await getAutditTrail(currentConsultantId);
    if (result?.success) {
      props.getUpdatedData(result?.payLoad);
    } else {
      props.getUpdatedData([]);
    }
  };
  useEffect(() => {
    fetchAuditTrail();
  }, [props.currentCard]);
  const balanceOfAssetsLinks = [
    {
      id: 1,
      name: t("assets-swiper-tab-1"),
      image: "/assets/icons/real-estate.png",
      multipleSteps: true,
      isUpdated:
        props.updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[0] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[0]?.toLowerCase()
        ).length > 0,
    },
    {
      id: 2,
      name: t("assets-swiper-tab-2"),
      image: "/assets/icons/bank-balances.png",

      multipleSteps: false,
      isUpdated:
        props.updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[1] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[1]?.toLowerCase()
        ).length > 0,
    },
    {
      id: 3,
      name: t("assets-swiper-tab-3"),
      image: "/assets/icons/securities.png",

      multipleSteps: false,
      isUpdated:
        props.updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[2] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[2]?.toLowerCase()
        ).length > 0,
    },
    {
      id: 4,
      name: t("assets-swiper-tab-4"),
      image: "/assets/icons/insurances.png",

      multipleSteps: true,
      isUpdated:
        props.updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[3] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[3]?.toLowerCase()
        ).length > 0,
    },
    {
      id: 5,
      name: t("assets-swiper-tab-5"),
      image: "/assets/icons/gold-raw-materials.png",

      multipleSteps: true,
      isUpdated:
        props.updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[4] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[4]?.toLowerCase()
        ).length > 0,
    },
    {
      id: 6,
      name: t("assets-swiper-tab-6"),
      image: "/assets/icons/share-holdings.png",

      multipleSteps: false,
      isUpdated:
        props.updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[5] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[5]?.toLowerCase()
        ).length > 0,
    },
    {
      id: 7,
      name: t("assets-swiper-tab-7"),
      image: "/assets/icons/co-share-holdings.png",

      multipleSteps: false,
      isUpdated:
        props.updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[6] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[6]?.toLowerCase()
        ).length > 0,
    },
    {
      id: 8,
      name: t("loans"),
      image: "",

      multipleSteps: false,
      isUpdated:
        props.updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[7] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[7]?.toLowerCase()
        ).length > 0,
    },
    {
      id: 9,
      name: t("assets-swiper-tab-8"),
      image: "",

      multipleSteps: false,
      isUpdated:
        props.updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[8] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[8]?.toLowerCase()
        ).length > 0,
    },
  ];

  const { tab, currentCard, custom, resetCard } = props;
  return (
    <Box className="boa-swiper">
      <Swiper
        onSwiper={handleSwiperScroll}
        cssMode={true}
        breakpoints={{
          // when window width is >= 320px
          280: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          // when window width is >= 640px

          640: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          // when window width is >= 900px
          900: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        }}
        navigation={true}
        mousewheel={true}
        keyboard={true}
        modules={[Navigation, Mousewheel, Keyboard]}
        className="mySwiper"
      >
        <Box component="div" className="steps" display="flex">
          {balanceOfAssetsLinks.map((item, index, arr) => (
            <SwiperSlide
              className={`  "swiper-slide" ${
                tab === item.id && item.multipleSteps
                  ? "swiper-slide-with-arrow"
                  : "swiper-slide"
              }`}
              key={index}
            >
              <Box
                key={item.id}
                sx={{
                  position: "relative",
                  padding: "10px 0 0 0",
                }}
              >
                <Box
                  component="div"
                  display="flex"
                  sx={{
                    position: "absolute",
                    zIndex: "100000  !important ",
                    top: "-10%",
                    left: `${index !== arr.length - 1 ? "-45%" : "-180%"}`,
                    padding: "5px ",
                    width: `${index !== arr.length - 1 ? "210px" : "100px"}`,
                    justifyContent: "center",
                  }}
                >
                  {item.image ? (
                    <Box component="img" src={item.image} width="20px" />
                  ) : null}
                  <Typography
                    variant="inherit"
                    fontSize="14px"
                    fontWeight="500"
                    marginLeft={1}
                  >
                    {item.name}
                  </Typography>
                </Box>

                <Box
                  component="div"
                  marginTop={1}
                  display="flex"
                  alignItems="center"
                  paddingTop={1}
                  paddingBottom={1}
                  // paddingLeft={10}
                >
                  {tab === item.id && item.multipleSteps ? (
                    currentCard === 1 ? (
                      <Box
                        component="img"
                        src={downArrow}
                        width="12px"
                        sx={{
                          position: "absolute",
                          left: "-15px",
                          top: "34px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          props.nextCard();
                        }}
                      />
                    ) : (
                      <Box
                        component="img"
                        src={upArrow}
                        width="12px"
                        sx={{
                          position: "absolute",
                          left: "-15px",
                          top: "34px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          props.preCard();
                        }}
                      />
                    )
                  ) : null}
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      backgroundColor: tab === item.id ? "#444561" : "#957ba0",
                      boxShadow: item.isUpdated
                        ? "0px 0px 7px 5px rgba(194,152,187,1)"
                        : "none",
                    }}
                    onClick={() => {
                      custom(index + 1);
                      resetCard();
                    }}
                  />
                  {index !== arr.length - 1 && (
                    <Box
                      component="div"
                      height={6}
                      width="185px"
                      marginLeft="0.3rem"
                      sx={{ backgroundColor: "color.magentaMid2" }}
                    />
                  )}
                </Box>
              </Box>
            </SwiperSlide>
          ))}
        </Box>
      </Swiper>
    </Box>
  );
};

function mapStateToProps(state) {
  return {
    currentCard: state.currentCard.currentCard,
    updates: state.auditTrail.updates,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextCard: () => dispatch(nextCard()),
    preCard: () => dispatch(preCard()),
    resetCard: () => dispatch(resetCard()),
    getUpdatedData: (data) => dispatch(getUpdatedData(data)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Steps);
